export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13148.2283d6e3.jpg";